import { useCallback, useState } from 'react'

import { COLLAPSED_STORAGE_KEY } from '../constants'

/**
 * Sezione collassabile con stato persistente in localStorage.
 * @param {Object} props
 * @param {string} props.id - Identificativo univoco per la persistenza
 * @param {string} props.title - Titolo della sezione
 * @param {string} [props.icon] - Classe icona PrimeIcons (es. 'pi pi-cog')
 * @param {React.ReactNode} [props.badge] - Badge opzionale a destra del titolo
 * @param {boolean} [props.defaultCollapsed=false] - Stato iniziale
 * @param {React.ReactNode} props.children - Contenuto della sezione
 */
export function CollapsibleSection({ id, title, icon, badge, defaultCollapsed = false, children }) {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(COLLAPSED_STORAGE_KEY) || '{}')
      return stored[id] !== undefined ? stored[id] : defaultCollapsed
    } catch (_) {
      return defaultCollapsed
    }
  })

  const handleToggle = useCallback(() => {
    setIsCollapsed((prev) => {
      const next = !prev
      try {
        const stored = JSON.parse(localStorage.getItem(COLLAPSED_STORAGE_KEY) || '{}')
        stored[id] = next
        localStorage.setItem(COLLAPSED_STORAGE_KEY, JSON.stringify(stored))
      } catch (_) {
        /* ignore */
      }
      return next
    })
  }, [id])

  return (
    <div className="nsec community-section">
      <div
        className="nsec__head"
        onClick={handleToggle}
        style={{ cursor: 'pointer', userSelect: 'none' }}
        role="button"
        tabIndex={0}
        aria-expanded={!isCollapsed}
        aria-label={`${isCollapsed ? 'Espandi' : 'Comprimi'} ${title}`}
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleToggle()}
      >
        {icon && (
          <div className="nsec__ico">
            <i className={icon} style={{ fontSize: 16 }} />
          </div>
        )}
        <h3 className="nsec__title">{title}</h3>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
          {badge}
          <i
            className={`pi ${isCollapsed ? 'pi-chevron-down' : 'pi-chevron-up'}`}
            style={{ fontSize: 12, color: 'var(--ink-500)', transition: 'transform 0.2s' }}
          />
        </div>
      </div>
      {!isCollapsed && <div className="nsec__body">{children}</div>}
    </div>
  )
}
